/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  Autocomplete,
  AutocompleteRenderOptionState,
  Box,
  Checkbox,
  LinearProgress,
  Tooltip,
  TextField,
} from "@mui/material";
import { ChangeEventHandler, useEffect, useRef, useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "../EditTenant/EditTenantPage.scss";
import addLogo from "../../images/addLogo.png";
import DefaultProfileImgDark from "../../images/DefaultProfileImgDark.png";
import {
  editTenantDetails,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getGeoMapping,
  getTenantDetailsByTenantId,
  getTenantLogo,
  uploadTenantLogoDetails,
} from "../../store/Tenant/tenant-actions";
import {
  GeoMapping,
  IErrorProps,
  MappingCountry,
  MappingRegion,
  MappingState,
  OptionsProduct,
  OptionsUtilityType,
  OptionsTimeZone,
} from "../../models";
import { AppDispatch, RootState } from "../../store";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import IFile from "../Image/types/File";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import updateErrorList from "../../utils/methods/updateErrorList";
import {
  Button,
  ControlError,
  Select,
  Input,
  Label,
  SelectOption,
  MoreVerticalIcon,
  Card,
  Chip,
  ChipRemove,
} from "@forge/common";
import Footer from "../SetupTenant/Footer/Footer";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../TenantUser/setErrorPopupsusingErrorCode";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import SuccessDialog from "../SharedComponents/SuccessDialog";
import useLocalStorageChange from "../../hooks/useLocalStorageChange";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";
import { UTILITY_TYPES_OPTIONS } from "../../utils/constants";
import { formatLatitudeForUI, formatLongitudeForUI, latitudeFromAPI, latitudeToAPI, longitudeFromAPI, longitudeToAPI, validateLatitude, validateLongitude } from "../../utils/coordinateUtils";

// Constants
const SELECT_ALL_PRODUCT = "Select All";
const HOME_CRUMB_ID = "Home";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EditTenantPage = () => {
  const [t] = useTranslation();
  const [theme, setCurrentTheme] = useState(
    localStorage.getItem("currentTheme") || "light"
  );
  const isInitialComponentRender = useRef(true);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const [tenantNameDefaultValue, setTenantNameDefaultValue] =
    useState<string>("");
  const [headquarterAddressDefaultValue, setHeadquarterAddressDefaultValue] =
    useState<string>("");
  const [organizationNameDefaultValue, setOrganizationNameDefaultValue] =
    useState<string>("");
  const [organizationIdDefaultValue, setOrganizationIdDefaultValue] =
    useState<string>("");
  const [regionDefaultValue, setRegionDefaultValue] = useState<number>(0);
  const [addressDefaultValue, setAddressDefaultValue] = useState<any>({
    street: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  });
  const [currencyDefaultValue, setCurrencyDefaultValue] = useState<string>("");
  const [latitudeDefaultValue, setLatitudeDefaultValue] = useState<string>("");
  const [longitudeDefaultValue, setLongitudeDefaultValue] = useState<string>("");
  const [dataCenterDefaultValue, setDataCenterDefaultValue] = useState<string>("");
  const [timezoneDefaultValue, setTimezoneDefaultValue] = useState<number>(0);
  const [utilityTypeDefaultValueList, setUtilityTypeDefaultValueList] = useState<string[]>([]);
  const [productDefaultValueList, setProductDefaultValueList] = useState<
    string[]
  >([]);
  const [
    productsConcatenatedInAsDefaultValue,
    setProductsConcatenatedInAsDefaultValue,
  ] = useState("");
  const [
    utilityTypeConcatenatedInAsDefaultValue,
    setUtilityTypeConcatenatedInAsDefaultValue,
  ] = useState("");
  const [isFormDataChanged, setIsFormDataChanged] = useState<boolean>(false);

  const [regionMapping, setRegionMapping] = useState<Array<MappingRegion>>([]);
  const [countryMapping, setCountryMapping] = useState<Array<MappingCountry>>(
    []
  );
  const [stateMapping, setStateMapping] = useState<Array<MappingState>>([]);
  const [TimezoneMapping, setTimezoneMapping] = useState<
    Array<OptionsTimeZone>
  >([]);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  // Error lists
  const [errorGeoMapping, seterrorGeoMapping] = useState<Array<IErrorProps>>(
    []
  );
  const [enteredTenantName, setTenantName] = useState("");

  const [enteredheadquarterAddress, setheadquarterAddress] = useState("");
  const [enteredOrganizationName, setOrganizationName] = useState("");
  const [enteredOrganizationId, setOrganizationId] = useState("");
  const [enteredTimeZone, setTimeZone] = useState<string>("0");
  const [enteredDatacenter, setDataCenter] = useState("");
  const [enteredProduct, setProduct] = React.useState<OptionsProduct[]>([]);
  const [enteredProductSubmit, setProductSumbit] = React.useState<string[]>([]);
  const [enteredUtilityType, setUtilityType] = useState<OptionsUtilityType[]>([]);
  const [enteredUtilityTypeSubmit, setUtilityTypeSubmit] = useState<string[]>([]);
  const [tenanthasError, settenanthasError] = useState(false);
  const [AddresshasError, setAddresshasError] = useState(false);
  const [enteredCurrency, setCurrency] = useState("");
  const [tenantID, setTenantID] = useState("");
  const [currentImage, setCurrentImage] = useState<File>();
  const [previewImage, setPreviewImage] = useState<string>("");
  const [progress, setProgress] = useState<number>(0);
  const [message, setMessage] = useState<string>("");
  const [imageInfos, setImageInfos] = useState<Array<IFile>>([]);
  const [tenantCurrentLogo, setCurrentTenantLogo] = useState<string>("");
  const [enteredRegion, setRegion] = useState("");
  const [addressHasError, setAddressHasError] = useState<{ street?: boolean; city?: boolean; zipcode?: boolean; state?: boolean; country?: boolean }>({});
  const [enteredAddress, setEnteredAddress] = useState<any>({
    street: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  });

  const [latitudehasError, setLatitudehasError] = useState<boolean>(false);
  const [enteredLatitude, setLatitude] = useState("");

  const [longitudehasError, setLongitudehasError] = useState<boolean>(false);
  const [enteredLongitude, setLongitude] = useState("");

  const [allSelected, setAllSelected] = useState(false);
  const [allSelectedUT, setAllSelectedUT] = useState(false);

  const optionsGeoMapping: GeoMapping = useSelector(
    (state: RootState) => state.cart.geoMapping
  );

  const [isCountryDisabled, setIsCountryDisabled] = useState(false);
  const [isStateDisabled, setIsStateDisabled] = useState(false);

  const [isTimeZoneDisabled, setIsTimeZoneDisabled] = useState(false);
  const [stateForDropDownCountryMapping, setStateForDropDownCountryMapping] =
    useState(1);
  const [stateForDropDownStateMapping, setStateForDropDownStateMapping] =
    useState(1);
  const [stateForDropDownTimeZoneMapping, setStateForDropDownTimeZoneMapping] =
    useState(1);
  const [showAll, setShowAll] = useState(false);
  const [showAllUT, setShowAllUT] = useState(false);

  const optionsDataCenter = useSelector(
    (state: RootState) => state.cart.availableDataCentres
  );
  let prodOptions: OptionsProduct[] = [
    { productId: SELECT_ALL_PRODUCT, settings: [], productName: SELECT_ALL_PRODUCT },
  ];
  const optionsProduct = prodOptions.concat(
    useSelector((state: RootState) => state.cart.availableProducts)
  );
  const optionsProductFromStore = useSelector(
    (state: RootState) => state.cart.availableProducts
  );

  let utOptions: OptionsUtilityType[] = [
    { id: SELECT_ALL_PRODUCT, name: SELECT_ALL_PRODUCT },
  ];
  const optionsUtilityType = utOptions.concat(
    useSelector((state: RootState) => UTILITY_TYPES_OPTIONS)
  );
  const optionsUtilityTypeFromStore = useSelector(
    (state: RootState) => UTILITY_TYPES_OPTIONS
  );

  const optionsCurrency = useSelector(
    (state: RootState) => state.cart.availableCurrencies
  );
  const userPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  const [isProductUpdateAllowed, setIsProductUpdateAllowed] = useState(false);
  const [isTenantUpdateAllowed, setIsTenantUpdateAllowed] = useState(false);

  useLocalStorageChange("currentTheme", (updatedTheme) => {
    if (updatedTheme) {
      setCurrentTheme(updatedTheme);
    }
  });

  useEffect(() => {
    setIsTenantUpdateAllowed(userPermissions.can_update_tenant);
    setIsProductUpdateAllowed(userPermissions.can_update_tenant_product);
  }, [
    userPermissions.can_update_tenant,
    userPermissions.can_update_tenant_product,
  ]);

  // All useState are for dropdown "key" field
  useEffect(() => {
    setStateForDropDownCountryMapping(stateForDropDownCountryMapping + 1);
  }, [countryMapping, enteredAddress.country]);
  useEffect(() => {
    setStateForDropDownStateMapping(stateForDropDownStateMapping + 1);
  }, [enteredAddress.country]);
  useEffect(() => {
    setStateForDropDownTimeZoneMapping(stateForDropDownTimeZoneMapping + 1);
  }, [enteredRegion, TimezoneMapping]);
  // TODO: need to recalculate based on GeoMapping data

  const TenantNameRegex = /^[a-zA-Z\s]*$/; // Only allows alphanumeric characters
  const AddressRegex = /^[a-zA-Z0-9,\s\.\-]*$/; // Only allows alphanumeric charactersconst getCountryNameById = (id: string): string | undefined => {
  const isUpdated = useRef({
    tenantName: false,
    headquarterAddress: false,
    organizationName: false,
    organizationId: false,
    region: false,
    address: false,
    latitude: false,
    longitude: false,
    tenantDataCenter: false,
    products: false,
    utilityType: false,
    currency: false,
    timezone: false,
    profilePic: false,
  });
  // istanbul ignore next
  // Get region By Id
  const getRegionById = (RegionId: string): string | undefined => {
    const region = regionMapping.find((c) => c.id === +RegionId);
    return region?.name;
  };

  const onBackBtn = () => {
    // if (tenantDetails?.status === "SetupCompleted") {
    navigate(-1);
    // }
    //#TODO - check if we need to navigate to tenant/user and fetch before tenant details we navigate
  };

  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === HOME_CRUMB_ID) {
      navigate("/tenant/user");
    }
  };
  
  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.id === +enteredAddress.country
    );
    let state: Array<MappingState> = [];

    if (x1 !== -1 && +enteredAddress.country === 1) {
      setIsStateDisabled(false);
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    } else {
      setIsStateDisabled(true);
    }
  }, [enteredAddress.country]);

  useEffect(() => {
    const newregionMapping: Array<MappingRegion> = [];
    optionsGeoMapping.regionDataMap.map((x) => {
      newregionMapping.push(x.region);
    });
    setRegionMapping(newregionMapping);
  }, [optionsGeoMapping]);

  useEffect(() => {
    let indexOfRegionData = optionsGeoMapping.regionDataMap.findIndex(
      (x) => x.region.id === +enteredRegion
    );

    let countries: Array<MappingCountry> = [];
    let timezone: Array<OptionsTimeZone> = [];
    // istanbul ignore next
    //for geomapping region finder
    if (indexOfRegionData !== -1) {
      countries = optionsGeoMapping.regionDataMap[indexOfRegionData].countries;
      timezone = optionsGeoMapping.regionDataMap[indexOfRegionData].timezones;
      setCountryMapping(countries);
      setTimezoneMapping(timezone);
    }
  }, [enteredRegion]);

  useEffect(() => {
    let x1 = optionsGeoMapping.countryDataMap.findIndex(
      (x) => x.country.id === +enteredAddress.country
    );
    let state: Array<MappingState> = [];
    // istanbul ignore next
    //for geomapping country finder
    if (x1 !== -1) {
      state = optionsGeoMapping.countryDataMap[x1].states;
      setStateMapping(state);
    }
  }, [enteredAddress.country]);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  // const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  // const errorRef = useRef<Array<IErrorProps>>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [openDialogforConflict, setopenDialogforConflict] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  const onDialogForConflictCloseHandler = () => {
    setopenDialogforConflict(false);
    navigate("/tenant");
  };

  //////////////Error Handling////////////////////////

  // API calls
  // Get Datacentres if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableDataCenters())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // Get Geo mapping
  useEffect(() => {
    if (optionsGeoMapping.countryDataMap?.length === 0) {
      setIsLoading(true);
      dispatch(getGeoMapping())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          seterrorGeoMapping(updateErrorList(error, [...errorGeoMapping]));
        })
        .finally(() => setIsLoading(false));
    }
  }, [optionsGeoMapping]);
  // Get currencies if not present
  useEffect(() => {
    if (optionsCurrency?.length === 0) {
      setIsLoading(true);
      dispatch(getAvailableCurrencies())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);
  // Get available products if not present
  useEffect(() => {
    if (optionsProduct?.length === 1) {
      // 1 because Select All is optionally added by default
      setIsLoading(true);
      dispatch(getAvailableProducts())
        .unwrap()
        .then(() => {})
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, []);

  // istanbul ignore next
  // Update for button disabled
  const handleUpdateBtnDisable = (
    defaultValue: any,
    newValue: any,
    fieldModified:
      | "tenant"
      | "headqtrAdd"
      | "organizationName"
      | "organizationId"
      | "region"
      | "address"
      | "utilityType"
      | "latitude"
      | "longitude"
      | "datacenter"
      | "product"
      | "currency"
      | "timeZone"
  ) => {
    const valueUpdated = checkIfValueCHanged(
      defaultValue === undefined || defaultValue === null ? "" : defaultValue,

      newValue === undefined || newValue === null ? "" : newValue
    );
    switch (fieldModified) {
      case "tenant":
        isUpdated.current = { ...isUpdated.current, tenantName: valueUpdated };
        break;

      case "headqtrAdd":
        isUpdated.current = {
          ...isUpdated.current,
          headquarterAddress: valueUpdated,
        };
        break;
      case "organizationName":
        isUpdated.current = {
          ...isUpdated.current,
          organizationName: valueUpdated,
        };
        break;
      case "organizationId":
        isUpdated.current = {
          ...isUpdated.current,
          organizationId: valueUpdated,
        };
        break;
      case "region":
        isUpdated.current = { ...isUpdated.current, region: valueUpdated };
        break;
      case "address":
        isUpdated.current = { ...isUpdated.current, address: valueUpdated };
        break;
      case "utilityType":
        isUpdated.current = { ...isUpdated.current, utilityType: valueUpdated };
        break;
      case "latitude":
        isUpdated.current = { ...isUpdated.current, latitude: valueUpdated };
        break;
      case "longitude":
        isUpdated.current = { ...isUpdated.current, longitude: valueUpdated };
        break;
      case "datacenter":
        isUpdated.current = {
          ...isUpdated.current,
          tenantDataCenter: valueUpdated,
        };
        break;
      case "product":
        isUpdated.current = { ...isUpdated.current, products: valueUpdated };
        break;
      case "currency":
        isUpdated.current = { ...isUpdated.current, currency: valueUpdated };
        break;
      case "timeZone":
        isUpdated.current = { ...isUpdated.current, timezone: valueUpdated };
        break;
      default:
        // Handle unknown field modification or provide a default case
        break;
    }
    const isAnyValueTrue = Object.values(isUpdated.current).some(
      (value) => value
    );

    if (isAnyValueTrue) {
      setIsFormDataChanged(true);
    } else {
      setIsFormDataChanged(false);
    }
  };
  const tenantDetails = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId
  );
  useEffect(() => {
    if (isInitialComponentRender.current) {
      var currency = optionsCurrency?.filter(function (item) {
        return item.name == tenantDetails?.currency;
      });

      var dataCenter = optionsDataCenter.filter(function (item) {
        return item.name == tenantDetails?.datacenter;
      });

      var timeZone = TimezoneMapping?.filter(function (item) {
        return item.name == tenantDetails?.timezone;
      });

      var country = countryMapping?.filter(function (item) {
        return item.name == tenantDetails?.address?.country;
      });

      var region = regionMapping?.filter(function (item) {
        return item.name == tenantDetails?.region;
      });
      var state = stateMapping?.filter(function (item) {
        return item.name  == tenantDetails?.address?.state;
      });

      var product = optionsProduct?.filter(function (productSelected) {
        return tenantDetails?.products?.some(
          (prod: { productId: string }) =>
            prod.productId === productSelected.productId
        );
      });

      var utilityType = optionsUtilityType?.filter(function (utilityTypeSelected) {
        const utilityTypeValues = (tenantDetails?.utilityType || "")
        .split(",")
        .map(item => item.toLowerCase().trim())
        .filter(Boolean)
        .map(item => ({
          id: item,
          name: item.charAt(0).toUpperCase() + item.slice(1)
        }));

        return utilityTypeValues.some(
          (ut: { id: string }) =>
            ut.id === utilityTypeSelected.id
        );
      });

      const organizationIdValue = tenantDetails?.groupId ?? tenantDetails?.organizationId ?? "";

      const latitudeValue = tenantDetails?.latitude ? latitudeFromAPI(String(tenantDetails.latitude)) : "";
      const longitudeValue = tenantDetails?.longitude ? longitudeFromAPI(String(tenantDetails.longitude)) : "";
      setLatitude(latitudeValue)
      setLongitude(longitudeValue)
      
      setLatitudeDefaultValue(latitudeValue)
      setLongitudeDefaultValue(longitudeValue)

      const addressData = {
        street: tenantDetails?.address?.street || "",
        city: tenantDetails?.address?.city || "",
        state: tenantDetails?.address?.state || "",
        country: tenantDetails?.address?.country || "",
        zipcode: tenantDetails?.address?.zipcode?.toString() || "",
      };
      setEnteredAddress(addressData);
      setAddressDefaultValue(addressData);
      setTenantName(tenantDetails?.tenantName);
      setTenantNameDefaultValue(tenantDetails?.tenantName);
      setheadquarterAddress(tenantDetails?.headquarterAddress ?? "");
      setHeadquarterAddressDefaultValue(
        tenantDetails?.headquarterAddress ?? ""
      );
      setOrganizationName(tenantDetails?.organizationName ?? "");
      setOrganizationNameDefaultValue(tenantDetails?.organizationName ?? "");
      setOrganizationId(organizationIdValue);
      setOrganizationIdDefaultValue(organizationIdValue);

      setTenantID(tenantDetails?.tenantId);

      // setTenantID((params as any).id);
      // istanbul ignore next

      if (country?.length > 0) {
        setEnteredAddress((prev: any) => ({ ...prev, country: country[0].id.toString() }));
        if (country[0].id.toString() === "1" && stateMapping?.length > 0) {
          setEnteredAddress((prev: any) => ({ ...prev, state: state[0]?.id.toString() }));
          setStateForDropDownStateMapping(stateForDropDownStateMapping + 1);
        }
      }
      // istanbul ignore next
      //for geomapping region
      if (region?.length > 0) {
        setRegion(region[0].id as unknown as string);
        setRegionDefaultValue(region[0].id);
      }
      // istanbul ignore next
      //for  datatcenter setup
      if (dataCenter?.length > 0) {
        setDataCenter(dataCenter[0].id);
        setDataCenterDefaultValue(dataCenter[0].id);
      }
      // istanbul ignore next
      //for   setup timezone
      if (timeZone?.length > 0) {
        setTimeZone(timeZone[0].id);
        setTimezoneDefaultValue(Number(timeZone[0].id));
      }
      // istanbul ignore next
      //for  currency setup
      if (currency?.length > 0) {
        setCurrency(currency[0].id);
        setCurrencyDefaultValue(currency[0].id.toString());
      }
      // Option Product by default has " Select All" value.
      // So, we need to check if its more than 1.For others its more than 0
      // istanbul ignore next
      if (
        product !== null &&
        product !== undefined &&
        optionsProductFromStore?.length > 0
      ) {
        setProduct(product);
        setProductDefaultValueList(
          product.map((productDef) => productDef.productId)
        );
        setProductsConcatenatedInAsDefaultValue(
          product
            .map((x) => x.productId)
            .sort()
            .join("_")
        );
      }
      // For utilityType setup
      if (
        utilityType !== null &&
        utilityType !== undefined &&
        optionsUtilityTypeFromStore?.length > 0
      ) {
        setUtilityType(utilityType);
        setUtilityTypeDefaultValueList(
          utilityType.map((ut) => ut.id)
        );
        setUtilityTypeConcatenatedInAsDefaultValue(
          utilityType
            .map((x) => x.id)
            .sort()
            .join("_")
        );
      }
    }
  }, [
    tenantDetails,
    optionsDataCenter,
    optionsCurrency,
    optionsProductFromStore,
    optionsUtilityTypeFromStore,
    countryMapping,
    regionMapping,
    TimezoneMapping,
    stateMapping,
  ]);

  useEffect(() => {
    if (tenantID === "") {
    } else {
      setIsLoading(true);
      dispatch(getTenantLogo(tenantID))
        .unwrap()
        .then((response: any) => {
          setCurrentTenantLogo(response as string);
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    }
  }, [tenantID]);

  useEffect(() => {
    setProductSumbit(
      optionsProduct
        .filter(function (n) {
          return enteredProduct.indexOf(n) !== -1;
        })
        .map((x) => x.productId)
    );
  }, [enteredProduct]);

  useEffect(() => {
    setUtilityTypeSubmit(
      optionsUtilityType
        .filter(function (n) {
          return enteredUtilityType.indexOf(n) !== -1;
        })
        .map((x) => x.id)
    );
  }, [enteredUtilityType]);

  const [errors, setErrors] = useState({
    custName: "",
    address1: "",
    timezone: "",
    datacenter: "",
    currency: "",
    // applications: "",
    // forgeId: "",
    tenantId: "",
    //country: "",
    region: "",
    //state: "",
  });

  const params = useParams();

  // const TenantNameChangeHandler = (event: any) => {
  //   isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
  //   setTenantName(event.target.value);
  //   if (TenantNameRegex.test(event.target.value)) {
  //     settenanthasError(false);
  //   } else {
  //     settenanthasError(true);
  //   }
  //   handleUpdateBtnDisable(
  //     tenantNameDefaultValue,
  //     event.target.value.toString(),
  //     "tenant"
  //   );
  // };

  // istanbul ignore next
  const headquarterAddressChangeHandler = (event: any) => {
    setheadquarterAddress(event.target.value);
    if (AddressRegex.test(event.target.value)) {
      setAddresshasError(false);
    } else {
      setAddresshasError(true);
    }
    handleUpdateBtnDisable(
      headquarterAddressDefaultValue,
      event.target.value.toString(),
      "headqtrAdd"
    );
  };

  // istanbul ignore next
  const organizationNameChangeHandler = (event: any) => {
    setOrganizationName(event.target.value);
    handleUpdateBtnDisable(
      organizationNameDefaultValue,
      event.target.value.toString(),
      "organizationName"
    );
  };

  // istanbul ignore next
  const organizationIdChangeHandler = (event: any) => {
    setOrganizationId(event.target.value);
    handleUpdateBtnDisable(
      organizationIdDefaultValue,
      event.target.value.toString(),
      "organizationId"
    );
  };

  // istanbul ignore next
  const dataCenterChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setDataCenter(event.target.value);

    handleUpdateBtnDisable(
      dataCenterDefaultValue.toString(),
      event.target.value.toString(),
      "datacenter"
    );
  };

  // istanbul ignore next
  const currencyChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setCurrency(event.target.value);
    handleUpdateBtnDisable(
      currencyDefaultValue,
      event.target.value.toString(),
      "currency"
    );
  };

  // istanbul ignore next
  const timezoneChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setTimeZone(event.target.value);
    handleUpdateBtnDisable(
      timezoneDefaultValue,
      event.target.value.toString(),
      "timeZone"
    );
  };

  // istanbul ignore next
  const countryChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setEnteredAddress((prev: any) => ({ ...prev, country: event.target.value, state: "" }));
    setTimezoneDefaultValue(0);
    handleUpdateBtnDisable(
      addressDefaultValue.country,
      event.target.value.toString(),
      "address"
    );
  };

  // istanbul ignore next
  const regionChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setRegion(event.target.value);
    // Enable country field after selecting "Region" field
    setIsCountryDisabled(false);
    setIsTimeZoneDisabled(false);
    setEnteredAddress((prev: any) => ({ ...prev, country: "", state: "" }));
    setTimeZone("");
    handleUpdateBtnDisable(
      regionDefaultValue.toString(),
      event.target.value.toString(),
      "region"
    );
  };

  // istanbul ignore next
  const stateChangeHandler: ChangeEventHandler<HTMLInputElement> = (event) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    setEnteredAddress((prev: any) => ({ ...prev, state: event.target.value }));
    handleUpdateBtnDisable(
      addressDefaultValue.state.toString(),
      event.target.value.toString(),
      "address"
    );
  };

  // istanbul ignore next
  const ZipcodeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequent renders
    setEnteredAddress((prev: any) => ({ ...prev, zipcode: event.target.value }));
    const regexpassed: RegExp = /^[a-zA-Z0-9s-]{3,15}$/;
    // Zip code is optional, so an empty value is valid; only validate non-empty input
    if (event.target.value === "" || regexpassed.test(event.target.value)) {
      setAddressHasError((prev: any) => ({ ...prev, zipcode: false }));
    } else {
      setAddressHasError((prev: any) => ({ ...prev, zipcode: true }));
    }

    handleUpdateBtnDisable(
      addressDefaultValue.zipcode,
      event.target.value.toString(),
      "address"
    );
  };

  // istanbul ignore next
  const StreetAddressChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequent renders
    setEnteredAddress((prev: any) => ({ ...prev, street: event.target.value }));
    setAddressHasError((prev: any) => ({ ...prev, street: false }));

    handleUpdateBtnDisable(
      addressDefaultValue.street,
      event.target.value.toString(),
      "address"
    );
  };

  // istanbul ignore next
  const CityChangeHandler = (event: any) => {
    isInitialComponentRender.current = false; // prevents to take location.state values for subsequent renders
    setEnteredAddress((prev: any) => ({ ...prev, city: event.target.value }));
    setAddressHasError((prev: any) => ({ ...prev, city: false }));

    handleUpdateBtnDisable(
      addressDefaultValue.city,
      event.target.value.toString(),
      "address"
    );
  };

  // istanbul ignore next
  const LatitudeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;

    const inputValue = event.target.value;
    
    // Import the lenient validation function at the top of the file
    // For now, just store the raw value - allow anything that looks like coordinates
    setLatitude(inputValue);
    
    // Only validate on blur, not during typing
    // This will be handled in LatitudeBlurHandler
  };

  const LatitudeBlurHandler = (event: any) => {
    const inputValue = event.target.value.trim();

    if (!inputValue) {
      setLatitude("");
      setLatitudehasError(false);
      handleUpdateBtnDisable(latitudeDefaultValue, "", "latitude");
      return;
    }

    const formatted = formatLatitudeForUI(inputValue);
    const isValid =
      formatted !== "" &&
      validateLatitude(formatted);

    if (!isValid) {
      setLatitudehasError(true);
      return;
    }

    setLatitude(formatted);
    setLatitudehasError(false);
    handleUpdateBtnDisable(latitudeDefaultValue, formatted, "latitude");
  };

  // istanbul ignore next
  const LongitudeChangeHandler = (event: any) => {
    isInitialComponentRender.current = false;

    const inputValue = event.target.value;
    
    setLongitude(inputValue);
    
    // Only validate on blur, not during typing
    // This will be handled in LongitudeBlurHandler
  };

  const LongitudeBlurHandler = (event: any) => {
    const inputValue = event.target.value.trim();

    if (!inputValue) {
      setLongitude("");
      setLongitudehasError(false);
      handleUpdateBtnDisable(longitudeDefaultValue, "", "longitude");
      return;
    }

    const formatted = formatLongitudeForUI(inputValue);
    const isValid =
      formatted !== "" &&
      validateLongitude(formatted);

    if (!isValid) {
      setLongitudehasError(true);
      return;
    }

    setLongitude(formatted);
    setLongitudehasError(false);
    handleUpdateBtnDisable(longitudeDefaultValue, formatted, "longitude");
  };

  // const goToSettingsPage = () => {
  //   setStepperState({
  //     ...stepperState,
  //     currentStep: "Settings",
  //     steps: stepperState.steps.map((step) => {
  //       if (step.id === "EditTenant") {
  //         return { ...step, status: "valid" };
  //       }
  //       return step;
  //     }),
  //   });
  // };
  // Handle application selection
  // istanbul ignore next

  const handleApplicationSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsProduct[]
  ) => {
    // Guard clause to check if selectedOptions, optionsProduct is null or undefined
    if (!selectedOptions || !optionsProduct) return;

    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    let selectedOptionValues: string[] = [];
    if (selectedOptions.find((option) => option.productId == SELECT_ALL_PRODUCT)) {
      if (selectedOptions?.length == optionsProduct?.length) {
        setProduct([]);
        setAllSelected(false);
      } else {
        setProduct(optionsProduct.slice(1));
        setAllSelected(true);
      }
    } else {
      if (selectedOptions?.length == optionsProduct?.length - 1) {
        setAllSelected(true);
      } else {
        setAllSelected(false);
      }
      setProduct(selectedOptions);
      /**To disable update button incase of no change in products selection */

      if (selectedOptions && selectedOptions?.length > 0) {
        selectedOptionValues = selectedOptions.map(
          (option) => option.productId
        );
      }
    }
    //#region Create newProductsConcatenatedValues
    let newProductsConcatenatedValues = selectedOptionValues.sort().join("_");
    if (
      selectedOptions?.length >= 0 &&
      selectedOptions.map((x) => x.productId).some((y) => y == SELECT_ALL_PRODUCT)
    ) {
      newProductsConcatenatedValues = optionsProduct
        .filter((x) => x.productId !== SELECT_ALL_PRODUCT)
        .map((y) => y.productId)
        .sort()
        .join("_");
      // Make select All to applicationId concatenanted string
    }
    //#endregion

    handleUpdateBtnDisable(
      productsConcatenatedInAsDefaultValue,
      newProductsConcatenatedValues,
      "product"
    );
  };

  // Handle UtilityType selection
  // istanbul ignore next
  const handleUtilityTypeSelection = (
    event: React.ChangeEvent<{}>,
    selectedOptions: OptionsUtilityType[]
  ) => {
    // Guard clause to check if selectedOptions, optionsUtilityType is null or undefined
    if (!selectedOptions || !optionsUtilityType) return;

    isInitialComponentRender.current = false; // prevents to take location.state values for subsequesnt renders
    let selectedOptionValues: string[] = [];
    if (selectedOptions.find((option) => option.id == SELECT_ALL_PRODUCT)) {
      if (selectedOptions?.length == optionsUtilityType?.length) {
        setUtilityType([]);
        setAllSelectedUT(false);
      } else {
        setUtilityType(optionsUtilityType.slice(1));
        setAllSelectedUT(true);
      }
    } else {
      if (selectedOptions?.length == optionsUtilityType?.length - 1) {
        setAllSelectedUT(true);
      } else {
        setAllSelectedUT(false);
      }
      setUtilityType(selectedOptions);
      /**To disable update button incase of no change in products selection */

      if (selectedOptions && selectedOptions?.length > 0) {
        selectedOptionValues = selectedOptions.map(
          (option) => option.id
        );
      }
    }
    //#region Create newUtilityTypesConcatenatedValues
    let newUtilityTypeConcatenatedValues = selectedOptionValues.sort().join("_");
    if (
      selectedOptions?.length >= 0 &&
      selectedOptions.map((x) => x.id).some((y) => y == SELECT_ALL_PRODUCT)
    ) {
      newUtilityTypeConcatenatedValues = optionsUtilityType
        .filter((x) => x.id !== SELECT_ALL_PRODUCT)
        .map((y) => y.id)
        .sort()
        .join("_");
      // Make select All to applicationId concatenanted string
    }
    //#endregion

    handleUpdateBtnDisable(
      utilityTypeConcatenatedInAsDefaultValue,
      newUtilityTypeConcatenatedValues,
      "utilityType"
    );
  };

  // istanbul ignore next
  // Check if the fields are filled
  // with input text
  const checkIfAnyTextFilled = () => {
    if (
      enteredTenantName === "" &&
      enteredheadquarterAddress === "" &&
      enteredCurrency === "" &&
      enteredDatacenter === "" &&
      // enteredProduct === []  &&
      enteredTimeZone === "" &&
      enteredAddress.country === "" &&
      enteredRegion === "" &&
      Object.values(addressHasError).some(error => error === true)
    )
      return true;
    else return false;
  };

  // istanbul ignore next
  // Handle submit
  function onSubmitHandeller() {
    //event.preventDefault();

    setCreateOpen(false);
    if (
      !validate() ||
      enteredProductSubmit?.length === 0 ||
      enteredUtilityTypeSubmit?.length === 0 ||
      Object.values(addressHasError).some(error => error === true) ||
      tenanthasError
    )
      return;
    let tenantId = tenantDetails.tenantId;

    const tenantToEdit: any = {
      //tenantName: enteredTenantName,
      headquarterAddress: enteredheadquarterAddress,
      organizationName: enteredOrganizationName || "",
      organizationId: enteredOrganizationId || "",
      timezone: enteredTimeZone, // string
      datacenter: +enteredDatacenter as unknown as number, // number
      currency: +enteredCurrency,
      region: enteredRegion as unknown as number,
      address: {
        street: enteredAddress.street || "",
        city: enteredAddress.city || "",
        zipcode: enteredAddress.zipcode || "",
        state: enteredAddress.state || "",
        country:
          enteredAddress.country !== ""
            ? (+enteredAddress.country as unknown as number)
            : "",
      },
      version: tenantDetails.version,
      status: tenantDetails.status,
      //products: enteredProductSubmit,
    };

    // For now pass the products as it is irrespective of permission
    if (userPermissions.can_update_tenant_product) {
      tenantToEdit.products = enteredProductSubmit;
    }

    if (enteredUtilityTypeSubmit) {
      tenantToEdit.utilityType = enteredUtilityTypeSubmit.join(",");
    }

    if (enteredLatitude) {
      const latitudeApiValue = latitudeToAPI(enteredLatitude);
      if (!latitudeApiValue) {
        setLatitudehasError(true);
        return;
      }
      tenantToEdit.latitude = latitudeApiValue;
    }
    if (enteredLongitude) {
      const longitudeApiValue = longitudeToAPI(enteredLongitude);
      if (!longitudeApiValue) {
        setLongitudehasError(true);
        return;
      }
      tenantToEdit.longitude = longitudeApiValue;
    }

    if (+enteredAddress.country === 1 && enteredAddress.state !== "") {
      tenantToEdit.address.state = +enteredAddress.state;
    }
    const postData = { ...tenantToEdit, id: tenantId };
    const ifAnyValueChanged = Object.values(isUpdated.current).some(
      (value) => value === true
    );
    const needToCallEditTenantApi = Object.entries(isUpdated.current)
      .filter(([key, value]: [string, boolean]) => key !== "profilePic")
      .some(([key, value]: [string, boolean]) => value === true);
    const parameters1: any = {
      tenantId: tenantID,
      fileName: currentImage,
      progressBar: null,
    };

    // If no chnage in Edit Tenant fields, directly go to next Settings page
    // Else If there is change in image, call Upload Tenant Logo API
    // Else if there is change in Edit Tenant fields, call Edit Tenant API
    // Else if there is change in both Edit Tenant fields and image, call Edit Tenant API and then Upload Tenant Logo API

    if (!ifAnyValueChanged) {
      return;
    } else if (!needToCallEditTenantApi) {
      setIsLoading(true);
      dispatch(uploadTenantLogoDetails(parameters1))
        .unwrap()
        .then(() => {
          navigate("/tenant/user");
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else if (isUpdated.current.profilePic === false) {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()
        //// Earlier code will be as it is
        .then((response: any) => {
          setIsLoading(false);
          setSuccessDialogOpen(true);
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error.error.response, [...prevState])
          );
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(true);
      dispatch(editTenantDetails(postData))
        .unwrap()
        .then(() => {
          dispatch(uploadTenantLogoDetails(parameters1))
            .unwrap()
            .then(() => {
              navigate("/tenant/user");
              // setStepperState({
              //   ...stepperState,
              //   currentStep: "Settings",
              //   steps: stepperState.steps.map((step) => {
              //     if (step.id === "EditTenant") {
              //       return { ...step, status: "valid" };
              //     }
              //     return step;
              //   }),
              // });
            })
            .catch((err) => {
              setErrorListGlobal((prevState) =>
                updateErrorList(err.error.response, [...prevState])
              );
            });
        })
        .catch((error) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error?.error?.response, [...prevState])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  // istanbul ignore next
  // Handle validate
  const validate = () => {
    let temp = {
      custName: enteredTenantName,
      address1: enteredheadquarterAddress,
      timezone: enteredTimeZone,
      datacenter: enteredDatacenter,
      currency: enteredCurrency,
      tenantId: tenantID,
     // country: enteredCountry,
      region: enteredRegion,
     // state: enteredState,
    };
    temp.custName = enteredTenantName ? "" : "This field is required";
    temp.tenantId = tenantID ? "" : "This field is required";
    temp.address1 = enteredheadquarterAddress ? "" : "This field is required";
    temp.currency = enteredCurrency ? "" : "This field is required";
    temp.datacenter = enteredDatacenter ? "" : "This field is required";
    temp.timezone = enteredTimeZone ? "" : "This field is required";
   // temp.country = enteredCountry ? "" : "This field is required";
    temp.region = enteredRegion ? "" : "This field is required";
    // temp.state = isStateDisabled || enteredState ? "" : "This field is required";
    setErrors({ ...temp });
    //setCreateOpen(true);
    return Object.values(temp).every((x) => x === "");
  };
  // istanbul ignore next
  // to validate regex exp for input fields
  const validateData = () => {
    if (
      !validate() ||
      enteredProductSubmit?.length === 0 ||
      enteredUtilityTypeSubmit?.length === 0 ||
      AddresshasError ||
      tenanthasError
    ) {
      return;
    }
    // If form is valid and no value is updated, directly go to next Settings page
    else if (
      validate() &&
      Object.values(isUpdated?.current)?.every((value) => value === false)
    ) {
    } else {
      setCreateOpen(true);
    }
  };

  const confirmCancelHandller = () => {
    setCancelOpen(false);
    navigate("/tenant");
  };

  // istanbul ignore next
  //while updating image
  const ImageUpload: React.FC = () => {
    const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFiles = event.target.files as FileList;
      const file = selectedFiles?.[0];
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.svg)$/i;
      const maxFileSize = 5 * 1024 * 1024; // 5 MB
      if (file) {
        if (!allowedExtensions.exec(selectedFiles?.[0].name)) {
          alert("Invalid Logo file format, please select a Image file");
          return false;
        }
        if (file.size > maxFileSize) {
          alert("File is too large, please select a file less than 5 MB");
          setPreviewImage("");
          return;
        }
        setCurrentImage(selectedFiles?.[0]);
        setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
        setProgress(0);
        // If image is updated , enable Update button
        isUpdated.current = { ...isUpdated.current, profilePic: true };
        setIsFormDataChanged(true);
      }
    };
    return (
      <div>
        <Button size="regular" variant="secondary" onClick={handleIconClick}>
          Update Logo
        </Button>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={selectImage}
          style={{ display: "none" }}
        />
        {currentImage && progress > 0 && (
          <div className="progress my-3">
            <div
              className="progress-bar progress-bar-info"
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: progress + "%", color: "red" }}
            >
              {progress}%
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </div>
        )}
        {message && (
          <div className="alert alert-secondary mt-3" role="alert">
            {message}
          </div>
        )}
        {imageInfos?.length > 0 && (
          <div className="card mt-3">
            <div className="card-header">List of Images</div>
            <ul className="list-group list-group-flush">
              {imageInfos.map((img, index) => (
                <li className="list-group-item" key={index}>
                  <p>
                    <a href={img.url}>{img.name}</a>
                  </p>
                  <img src={img.url} alt={img.name} height="80px" />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  // istanbul ignore next
  // to handle ToastBar Close
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  const [crumbs, setCrumbs] = useState([
    {
      id: HOME_CRUMB_ID,
      label: t(localeKeyMap.home),
    },
    {
      id: "edit-tenant",
      label: t(localeKeyMap.editTenantTitle),
    },
  ]);

  /**To deselct the products/applications */
  // istanbul ignore next
  //for handelling on delete
  const onDelete = (productId: any) => () => {
    let newSelectedApplications = enteredProduct.filter(
      (application) => application.productId !== productId
    );

    setProduct(newSelectedApplications);
    setAllSelected(false);
    handleUpdateBtnDisable(
      productsConcatenatedInAsDefaultValue,
      newSelectedApplications?.sort()?.join("_"),
      "product"
    );
  };

  // istanbul ignore next
  //for handelling on deleteUtilityType
  const onDeleteUtilityType = (id: any) => () => {
    let newSelectedApplications = enteredUtilityType.filter(
      (application) => application.id !== id
    );

    setUtilityType(newSelectedApplications);
    setAllSelectedUT(false);
    handleUpdateBtnDisable(
      utilityTypeConcatenatedInAsDefaultValue,
      newSelectedApplications?.map((ut) => ut.id)?.sort()?.join("_"),
      "utilityType"
    );
  };
  /**To render selected applicaton/product chips/tags with limit tag*/
  // istanbul ignore next
  //for handelling select all feature

  let chipStyle = {
    margin: "0 5px 5px 0",
    borderRadius: "4px",
    border: "1px solid F0F0F0",
    backgroundColor: "#FFF",
    boxShadow: "1px 1px 1px 0px rgba(0, 0, 0, 0.15)",
    fontWeight: "400",
  };

  const renderLimitedSelectedApplicationTags = () => {
    // Gaurd clause to check if enteredProduct is null or undefined
    if (!enteredProduct) return;

    let firstTwoTags = [];
    firstTwoTags = enteredProduct.slice(0, 2).map((v: any) => (
      <Chip
        key={v.productId}
        className="theme-chip"
        disabled={!isProductUpdateAllowed}
      >
        {v.productName}
        <ChipRemove
          onClick={onDelete(v.productId)}
          className="theme-chip-remove"
        >
          {v.productName}
        </ChipRemove>
      </Chip>
    ));

    return firstTwoTags.concat(
      <Chip
        className="theme-chip theme-chip-limit-tag"
        key="limit"
        onClick={() => {
          setShowAll(true);
        }}
      >
        {`+${enteredProduct?.length - 2}`}
      </Chip>
    );
  };

  /**To render all selected applications/products tags/chips */
  const renderAllSelectedApplicationTags = () => {
    return enteredProduct.map((v: any) => (
      <Chip
        key={v.productId}
        className="theme-chip"
        disabled={!isProductUpdateAllowed}
      >
        {v.productName}
        <ChipRemove
          onClick={onDelete(v.productId)}
          className="theme-chip-remove"
        >
          {v.productName}
        </ChipRemove>
      </Chip>
    ));
  };

  // Gaurd clause to check if enteredUtilityType is null or undefined
  const renderLimitedSelectedUtilityTypeTags = () => {
    if (!enteredUtilityType) return;

    let firstTwoTags = [];
    firstTwoTags = enteredUtilityType.slice(0, 2).map((v: any) => (
      <Chip
        key={v.id}
        className="theme-chip mb-1"
      >
        {v.name}
        <ChipRemove
          onClick={onDeleteUtilityType(v.id)}
          className="theme-chip-remove"
        >
          {v.name}
        </ChipRemove>
      </Chip>
    ));

    return firstTwoTags.concat(
      <Chip
        className="theme-chip theme-chip-limit-tag"
        key="limit"
        onClick={() => {
          setShowAllUT(true);
        }}
      >
        {`+${enteredUtilityType?.length - 2}`}
      </Chip>
    );
  };

  /**To render all selected applications/utilityTypes tags/chips */
  const renderAllSelectedUtilityTypeTags = () => {
    return enteredUtilityType.map((v: OptionsUtilityType) => (
      <Chip
        key={v.id}
        className="theme-chip mb-1"
      >
        {v.name}
        <ChipRemove
          onClick={onDeleteUtilityType(v.id)}
          className="theme-chip-remove"
        >
          {v.name}
        </ChipRemove>
      </Chip>
    ));
  };

  return (
    <>
      <>
        <BreadCrumbsComponent
          crumbs={crumbs}
          backbutton={true}
          backButtonHandler={onBackBtn}
          onCrumbClick={handleCrumbClick}
        />
        <Title
          title={t(localeKeyMap.editTenantTitle)}
          className="p-t15 p-b20"
        />

        <Card
          style={{ marginBottom: "50px" }}
          className="p-15 border-gray border-radius-10 create_tenant"
        >
          <div className="d-flex main_form_wrap">
            <div className="form_logo_wrap text-center color-bg-img">
              <div className="form_logo_image color-bg-profile-img-wrapper">
                {/* <img src={ProfileIcon} alt="Logo" /> */}

                {previewImage !== "" ? (
                  <img src={previewImage} alt="Logo" className="" />
                ) : tenantCurrentLogo === "" ? (
                  <img
                    src={theme === "dark" ? DefaultProfileImgDark : addLogo}
                    alt="Logo"
                    className=""
                  />
                ) : (
                  <img
                    src={`data:image/jpeg;base64,${tenantCurrentLogo}`}
                    alt="Logo"
                    className=""
                  />
                )}
              </div>
              <ImageUpload />

              {/* <Button size="regular" variant="secondary">
                Add Photo
              </Button> */}
            </div>
            <div className="form_box">
              <h4>{t(localeKeyMap.profileInformationTitle)}</h4>
              <div className="form_row">
                <div className="form_col">
                  <Label requiredText="*" className="mb-3">
                    {t(localeKeyMap.tenantNameLabel)} *
                  </Label>
                  <Input
                    required={true}
                    id="TenantName"
                    className="tenant-name"
                    placeholder={t(localeKeyMap.tenantNameLabel)}
                    size="regular"
                    disabled={true}
                    value={enteredTenantName}
                    //onChange={TenantNameChangeHandler}
                    maxLength={32}
                    // {...((errors.custName !== "" || tenanthasError) && {
                    //   error: true,
                    //   helperText: tenanthasError
                    //     ? "Tenant name can only contain alphabets"
                    //     : "This is a required field",
                    // })}
                  />
                </div>
                <div className="form_col">
                  <Label requiredText="*" className="mb-3">
                    {t(localeKeyMap.headquarterAddressLabel)} *
                  </Label>
                  <Input
                    className="headquarters-address"
                    id="Headquarters-Address"
                    placeholder={t(localeKeyMap.headquarterAddressLabel)}
                    size="regular"
                    maxLength={32}
                    value={enteredheadquarterAddress}
                    onChange={headquarterAddressChangeHandler}
                    {...((errors.address1 !== "" || AddresshasError) && {
                      error: true,
                      helperText: AddresshasError
                        ? t(localeKeyMap.addressHelperText)
                        : t(localeKeyMap.requiredField),
                    })}
                  />
                  {(AddresshasError || enteredheadquarterAddress === "") && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.organizationName)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="organization-name"
                    id="Organization-Name"
                    placeholder={t(localeKeyMap.organizationName)}
                    size="regular"
                    value={enteredOrganizationName}
                    maxLength={120}
                    onChange={organizationNameChangeHandler}
                  />
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.organizationId)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="organization-id"
                    id="Organization-ID"
                    placeholder={t(localeKeyMap.organizationId)}
                    size="regular"
                    value={enteredOrganizationId}
                    maxLength={120}
                    disabled={true}
                    onChange={organizationIdChangeHandler}
                  />
                </div>
                <div className="form_col">
                  <Label requiredText="*" className="mb-3"> {t(localeKeyMap.region)} *</Label>
                  <Select
                    className="dropdown_col"
                    id="Region"
                    key={`region-select-${enteredRegion}`}
                    // defaultValue={+regionDefaultValue}
                    placeholder={t(localeKeyMap.region)}
                    data-testid="SelectRegion"
                    size="regular"
                    value={+enteredRegion}
                    //onBlur={enteredRegionBlurHandler}
                    onChange={(event: any) => {
                      regionChangeHandler(event);
                    }}
                    // Enable country field after selecting "Region" field

                    {...(errors.region !== "" && (
                      <ControlError>
                        {t(localeKeyMap.requiredField)}
                      </ControlError>
                    ))}
                  >
                    {optionsGeoMapping?.regionDataMap
                      ?.slice()
                      .sort((a, b) => a.region.name.localeCompare(b.region.name))
                      .map((region) => {
                        return (
                          <SelectOption
                            key={region.region.id}
                            value={region.region.id}
                            label={region.region.name}
                          />
                        );
                      })}
                  </Select>
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.streetAddress)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="streetAddress"
                    id="streetAddress"
                    placeholder={t(localeKeyMap.streetAddress)}
                    value={enteredAddress.street}
                    size="regular"
                    onChange={(Event: any) => {
                      StreetAddressChangeHandler(Event);
                    }}
                  />
                  {addressHasError.street && enteredAddress.street !== "" && (
                    <ControlError>
                      {t(localeKeyMap.streetAddressHelperText)}
                    </ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.city)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="city"
                    id="city"
                    placeholder={t(localeKeyMap.city)}
                    value={enteredAddress.city}
                    size="regular"
                    onChange={(Event: any) => {
                      CityChangeHandler(Event);
                    }}
                  />
                  {addressHasError.city && enteredAddress.city !== "" && (
                    <ControlError>
                      {t(localeKeyMap.cityHelperText)}
                    </ControlError>
                  )}
                </div>
                {+enteredAddress.country === 1 && (
                  <div className="form_col">
                    <Label className="mb-3">{t(localeKeyMap.state)} <span className="text-muted"> - Optional</span></Label>
                    <Tooltip
                      title={
                        isStateDisabled && enteredAddress.country === "1"
                          ? t(localeKeyMap.selectCountryFirst)
                          : ""
                      }
                    >
                      <Select
                        id="State"
                        className="dropdown_col"
                        key={`state-select-${stateForDropDownStateMapping}`}
                        placeholder={t(localeKeyMap.state)}
                        data-testid="SelectState"
                        size="regular"
                        disabled={isStateDisabled}
                        value={Number(enteredAddress.state)}
                        onChange={(event) => {
                          stateChangeHandler(event);
                        }}
                      >
                        {stateMapping
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((state) => (
                            <SelectOption
                              key={state.id}
                              value={state.id}
                              label={state.name}
                            />
                          ))}
                      </Select>
                    </Tooltip>
                  </div>
                )}
                <div className="form_col">
                  <Label className="mb-3"> {t(localeKeyMap.country)} <span className="text-muted"> - Optional</span></Label>
                  <Tooltip
                    title={
                      isCountryDisabled ? t(localeKeyMap.selectRegionFirst) : ""
                    }
                  >
                    <Select
                      key={`country-select-${stateForDropDownCountryMapping}`}
                      id="Country"
                      className="dropdown_col"
                      placeholder={t(localeKeyMap.country)}
                      data-testid="SelectCountry"
                      size="regular"
                      disabled={isCountryDisabled}
                      // defaultValue={+addressDefaultValue.country}
                      value={Number(enteredAddress.country)}
                      onChange={(event) => {
                        countryChangeHandler(event);
                      }}
                      // {...((addressHasError.country ||
                      //   enteredCountrySubmitError) && {
                      //   error: true,
                      // })}
                    >
                      {countryMapping
                        ?.slice()
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((country) => (
                          <SelectOption
                            key={country.id}
                            value={country.id}
                            label={country.name}
                          />
                        ))}
                    </Select>
                  </Tooltip>
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.zipCode)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="zip-code"
                    id="Zip-Code"
                    placeholder={t(localeKeyMap.zipCode)}
                    value={enteredAddress.zipcode}
                    size="regular"
                    onChange={(Event: any) => {
                      //const event = NewEvent(Event);
                      ZipcodeChangeHandler(Event);
                    }}
                  />
                  {addressHasError.zipcode && enteredAddress.zipcode !== "" && (
                    <ControlError>
                      {t(localeKeyMap.zipcodeHelperText)}
                    </ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.latitude)} <span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="latitude"
                    id="latitude"
                    placeholder={t(localeKeyMap.latitude)}
                    value={enteredLatitude}
                    size="regular"
                    onChange={(Event: any) => {
                      LatitudeChangeHandler(Event);
                    }}
                    onBlur={(Event: any) => {
                      LatitudeBlurHandler(Event);
                    }}
                  />
                  {latitudehasError && enteredLatitude !== "" && (
                    <ControlError>
                      {t(localeKeyMap.latitudeHelperText)}
                    </ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3">{t(localeKeyMap.longitude)}<span className="text-muted"> - Optional</span></Label>
                  <Input
                    className="longitude"
                    id="longitude"
                    placeholder={t(localeKeyMap.longitude)}
                    value={enteredLongitude}
                    size="regular"
                    onChange={(Event: any) => {
                      LongitudeChangeHandler(Event);
                    }}
                    onBlur={(Event: any) => {
                      LongitudeBlurHandler(Event);
                    }}
                  />
                  {longitudehasError && enteredLongitude !== "" && (
                    <ControlError>
                      {t(localeKeyMap.longitudeHelperText)}
                    </ControlError>
                  )}
                </div>
              </div>
              <h4 className="other_info_title">
                {t(localeKeyMap.otherInformation)}
              </h4>
              <div className="form_row">
                <div className="form_col">
                  <Label className="mb-3" requiredText="*"> {t(localeKeyMap.tenantID)} * </Label>
                  <Input
                    className="tenant-id"
                    id="Tenant-ID"
                    placeholder={t(localeKeyMap.tenantID)}
                    size="regular"
                    disabled={true}
                    value={tenantID}
                    maxLength={32}
                    // onChange={(event: any) => {
                    //   ForgeIdChangeHandler(event);
                    // }}
                    // {...(errors.tenantId !== "" && {
                    //   error: true,
                    //   helperText: "This is a required field",
                    // })}
                  />
                </div>
                <div className="form_col">
                  <Label className="mb-3" requiredText="*">
                    {t(localeKeyMap.tenantCurrencyLabel)} *
                  </Label>
                  <Select
                    key={`currency-select-${enteredCurrency}`}
                    id="Tenant-Currency"
                    className="dropdown_col"
                    placeholder={t(localeKeyMap.tenantCurrencyLabel)}
                    data-testid="SelectCurrency"
                    size="regular"
                    // defaultValue={+currencyDefaultValue}
                    value={+enteredCurrency}
                    // onChange={enteredcurrencyChangeHandler}
                    onChange={(event) => {
                      currencyChangeHandler(event);
                    }}
                  >
                    {optionsCurrency
                      ?.slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((currency) => (
                        <SelectOption
                          key={currency.id}
                          value={currency.id}
                          label={currency.name}
                        />
                      ))}
                  </Select>
                  {errors.currency !== "" && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3" requiredText="*">
                    {t(localeKeyMap.tenantDataCenterLabel)} *
                  </Label>
                  <Select
                    className="dropdown_col"
                    key={`datacenter-select-${enteredDatacenter}`}
                    id="Tenant-Data-Center"
                    placeholder={t(localeKeyMap.tenantDataCenterLabel)}
                    data-testid="SelectDataCenter"
                    // defaultValue={
                    //   dataCenterDefaultValue ? +dataCenterDefaultValue : 0
                    // }
                    {...(errors.datacenter !== "" && {
                      error: true,
                    })}
                    value={+enteredDatacenter}
                    size="regular"
                    // onBlur={enteredDatacenterBlurHandler}
                    onChange={(event) => {
                      // event.preventDefault();
                      dataCenterChangeHandler(event);
                    }}
                  >
                    {optionsDataCenter
                      ?.slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((dataCenter) => (
                        <SelectOption
                          key={dataCenter.id}
                          value={dataCenter.id}
                          label={dataCenter.name}
                        />
                      ))}
                  </Select>
                  {errors.datacenter !== "" && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label className="mb-3" requiredText="*"> {t(localeKeyMap.timeZone)} * </Label>
                  <Tooltip
                    title={
                      isTimeZoneDisabled
                        ? t(localeKeyMap.selectRegionFirst)
                        : ""
                    }
                  >
                    <Select
                      className="dropdown_col"
                      id="Tenant-TimeZone"
                      key={`timezone-select-${stateForDropDownTimeZoneMapping}`}
                      placeholder={t(localeKeyMap.tenantTimeZone)}
                      size="regular"
                      data-testid="SelectTimeZone"
                      value={+enteredTimeZone}
                      onChange={(event) => {
                        timezoneChangeHandler(event);
                      }}
                    >
                      {TimezoneMapping
                        ?.slice()
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((timeZone) => (
                          <SelectOption
                            key={timeZone.id}
                            value={+timeZone.id}
                            label={timeZone.name}
                          />
                        ))}
                    </Select>
                  </Tooltip>
                  {enteredTimeZone === "" && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                  {/* 19 Feb Undo this change */}
                  {/* {(enteredTimeZoneHasError || enteredTimeZoneSubmitError) && (
                    <ControlError className={"requiredText"}>
                      This is a required field
                    </ControlError> 
                   )} */}
                </div>
                <div className="form_col">
                  <Label className="mb-3" requiredText="*">
                    {t(localeKeyMap.selectProductLabel)} *
                  </Label>
                  <Autocomplete
                    disabled={!isProductUpdateAllowed} // edit product is disabled for certain personas
                    data-testid="SelectProduct"
                    className={`multiselect-dropdown ${
                      enteredProduct.length === 0 && "disabled"
                    }`}
                    multiple
                    id="checkboxes-tags-demo"
                    options={[
                      ...optionsProduct.filter(option => option.productName === SELECT_ALL_PRODUCT),
                      ...optionsProduct
                        .filter(option => option.productName !== SELECT_ALL_PRODUCT)
                        .slice()
                        .sort((a, b) => a.productName.localeCompare(b.productName))
                    ]}
                    value={enteredProduct}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.productName}
                    onChange={handleApplicationSelection}
                    renderTags={() => null}
                    renderOption={(
                      props,
                      option: OptionsProduct,
                      { selected }: AutocompleteRenderOptionState
                    ) => {
                      if (option === null || option === undefined) {
                        return null;
                      }
                      const selectAllProps =
                        option.productName === t(localeKeyMap.selectAll)
                          ? { checked: allSelected }
                          : {};
                      return (
                        !allSelected && (
                          <li {...props}>
                            <Checkbox
                              className="dropdown"
                              icon={icon}
                              checkedIcon={checkedIcon}
                              checked={selected}
                              {...selectAllProps}
                            />
                            {option.productName}
                          </li>
                        )
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        autoComplete={"off"}
                        placeholder={
                          enteredProduct.length === 0
                            ? t(localeKeyMap.selectProductLabel)
                            : ""
                        }
                        sx={{
                          "& .MuiFormHelperText-root": {
                            marginTop: 0.1,
                            lineHeight: 0.9,
                          },
                          "& .MuiAutocomplete-root .MuiInputBase-input": {
                            height: "2rem",
                          },
                          "& .MuiInputBase-input::placeholder": {
                            fontSize: "14px",
                            fontWeight: "700",
                            opacity: "1",
                          },
                        }}
                        {...(enteredProductSubmit.length === 0 &&
                          true && {
                            error: true,
                          })}
                        {...params}
                      />
                    )}
                  />
                  {enteredProductSubmit.length === 0 && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                  <Box
                    sx={{
                      marginTop: "5px",
                    }}
                  >
                    {!showAll
                      ? enteredProduct.length > 2
                        ? renderLimitedSelectedApplicationTags()
                        : renderAllSelectedApplicationTags()
                      : renderAllSelectedApplicationTags()}
                  </Box>
                </div>
                <div className="form_col">
                  <Label className="mb-3" requiredText="*">
                    {t(localeKeyMap.selectUtilityTypeLabel)} *
                  </Label>
                  <Autocomplete
                    data-testid="SelectUtilityType"
                    className={`multiselect-dropdown`}
                    multiple
                    id="checkboxes-utility-types"
                    options={[
                      ...optionsUtilityType.filter(option => option.name === SELECT_ALL_PRODUCT),
                      ...optionsUtilityType
                        .filter(option => option.name !== SELECT_ALL_PRODUCT)
                        .slice()
                        .sort((a, b) => a.name.localeCompare(b.name))
                    ]}
                    value={enteredUtilityType}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    onChange={handleUtilityTypeSelection}
                    renderTags={() => null}
                    renderOption={(
                      props,
                      option: OptionsUtilityType,
                      { selected }: AutocompleteRenderOptionState
                    ) => {
                      if (option === null || option === undefined) {
                        return null;
                      }
                      const selectAllProps =
                        option.name === t(localeKeyMap.selectAll)
                          ? { checked: allSelectedUT }
                          : {};
                      return (
                        !allSelectedUT && (
                          <li {...props}>
                            <Checkbox
                              className="dropdown"
                              icon={icon}
                              checkedIcon={checkedIcon}
                              checked={selected}
                              {...selectAllProps}
                            />
                            {option.name}
                          </li>
                        )
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        autoComplete={"off"}
                        placeholder={
                          enteredUtilityType.length === 0
                            ? t(localeKeyMap.selectUtilityTypeLabel)
                            : ""
                        }
                        sx={{
                          "& .MuiFormHelperText-root": {
                            marginTop: 0.1,
                            lineHeight: 0.9,
                          },
                          "& .MuiAutocomplete-root .MuiInputBase-input": {
                            height: "2rem",
                          },
                          "& .MuiInputBase-input::placeholder": {
                            fontSize: "14px",
                            fontWeight: "700",
                            opacity: "1",
                          },
                        }}
                        {...(enteredUtilityTypeSubmit.length === 0 &&
                          true && {
                            error: true,
                          })}
                        {...params}
                      />
                    )}
                  />
                  {enteredUtilityTypeSubmit.length === 0 && (
                    <ControlError>{t(localeKeyMap.requiredField)}</ControlError>
                  )}
                  <Box
                    sx={{
                      marginTop: "5px",
                    }}
                  >
                    {!showAllUT
                      ? enteredUtilityType.length > 3
                        ? renderLimitedSelectedUtilityTypeTags()
                        : renderAllSelectedUtilityTypeTags()
                      : renderAllSelectedUtilityTypeTags()}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Footer
          //   #TODO cancelButtonRequired={tenantDetails?.status === "SetupCompleted"}
          // disabling as of now since we not sure with states after updating a setting
          cancelButtonRequired={true}
          disableSave={!isFormDataChanged || addressHasError.zipcode}
          openDialogCreate={createOpen}
          setOpenDialogCreate={setCreateOpen}
          openDialogCreateHeading={t(localeKeyMap.editTenantTitle)}
          openDialogCreateContent={t(localeKeyMap.confirmUpdateTenant)}
          openDialogonClose={false}
          openDialogCancel={false}
          dialogCreatePrimaryBtnLabel={t(localeKeyMap.update)}
          dialogCreateSecondaryBtnLabel={t(localeKeyMap.cancel)}
          setOpenDialogCancel={function (value: boolean): void {}}
          onBackBtn={onBackBtn}
          cancelBtnLabel={t(localeKeyMap.cancel)}
          createBtnLabel={t(localeKeyMap.update)}
          checkIfAnyTextFilled={checkIfAnyTextFilled}
          onSubmit={onSubmitHandeller}
          validate={validateData}
        />

        {/* ///////////////// New Footer End ////////////// */}
        {/* Footer end */}
      </>
      {isLoading && <Loader />}
      <div>
        {successDialogOpen && (
          <SuccessDialog
            open={successDialogOpen}
            title={t(localeKeyMap.tenantUpdated)}
            successMessage={
              <div>
                Please navigate to the tenant page if you need to update any
                settings. Click on
                <span
                  style={{
                    display: "inline-block",
                    color: "#0071B3",
                  }}
                >
                  <MoreVerticalIcon strokeWidth={3} />
                </span>
                icon, then{" "}
                <strong className="data-viz-subtitle-3">More Info</strong>, then{" "}
                <strong className="data-viz-subtitle-3">Edit Settings</strong>.
                Review your changes and, when you're ready, click{" "}
                <strong className="data-viz-subtitle-3">Publish</strong> to
                activate the changes.
              </div>
            }
            // SucessConfirmationMessage="Please navigate to the tenant page if you need to update any settings. Click on 'More Info', then 'Edit Settings'. Review your changes and, when you're ready, click 'Publish' to activate the tenant. If you need further assistance, don't hesitate to reach out."
            // SucessConfirmationMessage="Please go and update settings if needed in tenant page => more info=> edit settings and finally click on publish to make tenant active"
            handleClose={() => {
              dispatch(getTenantDetailsByTenantId({ tenantId: tenantID }))
                .finally(() => navigate("/tenant/user"));
            }}
          />
        )}
        <ErrorHandlingComponent
          openToast={openToastError}
          onCloseToast={handleToastBarClose}
          errorList={errorListGlobal.concat(toastErrors.current)}
          openServerError={openDialogServerError}
          onCloseServerError={onDialogForServerCloseHandler}
          openNoURL={openDialogNoURLError}
          onCloseNoURL={onDialogForNOURLCloseHandler}
          openDialogforConflict={openDialogforConflict}
          onCloseServerConflictError={onDialogForConflictCloseHandler}
        />
      </div>
    </>
  );
};
function checkIfValueCHanged(defaultValue: string, newValue: string) {
  if (defaultValue === newValue) {
    return false;
  } else {
    return true;
  }
}

export default EditTenantPage;
